import Button from '../../../components/base/Button';

export default function LocationSection() {
  return (
    <section id="location" className="py-20 bg-stone-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-stone-900 mb-4">
            Come Sip With Us
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Visit our café in Majnu-ka-tilla for the complete Roaffees experience
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="bg-stone-50 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-stone-900 mb-6">Visit Our Café</h3>
            
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-amber-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-white"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-stone-900 mb-1">Address</h4>
                  <p className="text-gray-600">Gate No. 4, New Camp, D-41, IDA House Shop No. 2<br />New Aruna Colony, Majnu-ka-tilla<br />New Delhi, Delhi 110054</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-amber-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-white"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-stone-900 mb-1">Hours</h4>
                  <p className="text-gray-600">
                    Monday - Sunday: 8:30 AM - 9:30 PM
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-amber-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-star-fill text-white"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-stone-900 mb-1">Rating</h4>
                  <p className="text-gray-600">5.0 ⭐ (147 Google reviews)</p>
                </div>
              </div>
            </div>
            
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <a 
                href="https://www.google.co.in/maps/place/Roaffees+%7C+Coffee+%26+Matcha/@28.703657,77.2255059,17z/data=!3m1!4b1!4m6!3m5!1s0x390cfbcc8b637531:0x28bcbae7a0439d25!8m2!3d28.703657!4d77.2280808!16s%2Fg%2F11y94m9t8j?entry=ttu&g_ep=EgoyMDI1MTEyMy4xIKXMDSoASAFQAw%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1"
              >
                <Button size="lg" className="w-full">
                  <i className="ri-direction-line mr-2"></i>
                  Get Directions
                </Button>
              </a>
              <a 
                href="https://www.google.co.in/maps/place/Roaffees+%7C+Coffee+%26+Matcha/@28.703657,77.2255059,17z/data=!3m1!4b1!4m6!3m5!1s0x390cfbcc8b637531:0x28bcbae7a0439d25!8m2!3d28.703657!4d77.2280808!16s%2Fg%2F11y94m9t8j?entry=ttu&g_ep=EgoyMDI1MTEyMy4xIKXMDSoASAFQAw%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1"
              >
                <Button variant="outline" size="lg" className="w-full">
                  <i className="ri-google-line mr-2"></i>
                  View Reviews
                </Button>
              </a>
            </div>
          </div>
          
          <div className="rounded-2xl overflow-hidden shadow-lg">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3500.3!2d77.2!3d28.7!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjjCsDQyJzAwLjAiTiA3N8KwMTInMDAuMCJF!5e0!3m2!1sen!2sin!4v1635789012345!5m2!1sen!2sin"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Roaffees Café Location"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}